import { defineNuxtPlugin } from '#app'
import { Tooltip } from 'floating-vue'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('v-tooltip', Tooltip)
})
